import {AbstractControl, FormArray, UntypedFormArray, UntypedFormControl, UntypedFormGroup, ValidatorFn} from '@angular/forms';
import {isBlank, isPresent} from '../utilities/utils';

export function dateRangeOverlap(startDate: string, endDate: string): ValidatorFn {
  return (formArray: AbstractControl): { [key: string]: boolean } => {
    const controls: AbstractControl[] = (formArray as UntypedFormArray).controls.filter((formGroup: AbstractControl) => {
      return isPresent(formGroup.get(startDate).value) && isPresent(formGroup.get(endDate).value);
    });
    const rangeOverlapObj: any = {rangeOverlap: true};
    let find = false;

    if (controls.length > 0) {
      controls.map(formGroup => formGroup.get(startDate)).forEach(x => {
        if (x.errors) {
          delete x.errors['rangeOverlap'];
        }
        if (isBlank(x.errors)) {
          x.setErrors(undefined);
        }
      });

      for (let i = 0; i < controls.length; i++) {
        const formGroup: UntypedFormGroup = controls[i] as UntypedFormGroup;
        const mainStartControl: AbstractControl = formGroup.get(startDate);
        const mainEndControl: AbstractControl = formGroup.get(endDate);
        const mainStartDate: Date = new Date(mainStartControl.value);
        const mainEndDate: Date = new Date(mainEndControl.value);

        controls.forEach((group: AbstractControl, index: number) => {
          if (i === index) {
            return;
          }

          const currStartControl: any = group.get(startDate);
          const currEndControl: any = group.get(endDate);
          const currStartValue: Date = new Date(currStartControl.value);
          const currEndValue: Date = new Date(currEndControl.value);
          let newErrors: any;

          if (Math.max(mainStartDate.getTime(), currStartValue.getTime()) < Math.min(mainEndDate.getTime(), currEndValue.getTime())) {
            if (isBlank(currStartControl.errors)) {
              newErrors = rangeOverlapObj;
            } else {
              newErrors = Object.assign(currStartControl.errors, rangeOverlapObj);
            }
            currStartControl.setErrors(newErrors);
            find = true;
          }
        });
      }

      if (find) {
        return rangeOverlapObj;
      }
    } else if (controls.length === 1) {
      const currControl: any = controls[0].get(startDate);

      if (!isBlank(currControl.errors)) {
        currControl.setErrors(undefined);
      }
    }

    return undefined;
  };
}
